/**
 * #1644 コース品目 (dishList 自由テキスト) の共通表示。
 *
 * 予約前 (コース詳細)・予約履歴・注文履歴の 3 画面で同じ改行規則 (pre-wrap =
 * 店主が入れた空白も保持) にする — 画面ごとに potong されると「約束した内容」が
 * 予約前と後で違って見える。
 */
export default function DishListPanel({
  dishList,
  size = 'sm',
}: {
  dishList: string
  /** sm = コース詳細 (主役表示) / xs = 履歴カード内の補足表示 */
  size?: 'sm' | 'xs'
}) {
  return (
    <p
      className={`whitespace-pre-wrap rounded-lg bg-gray-50 font-body leading-relaxed ${
        size === 'sm' ? 'p-3 text-sm text-text-primary' : 'px-2.5 py-2 text-xs text-text-secondary'
      }`}
    >
      {dishList}
    </p>
  )
}
